(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[914],{

/***/ 593:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[handle]",
      function () {
        return __webpack_require__(1876);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Collection; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(1529);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/snippets/index.js + 287 modules
var snippets = __webpack_require__(8169);
;// CONCATENATED MODULE: ./src/templates/collection.jsx





function CollectionTemplate(param) {
    var collection = param.collection, productsReady = param.productsReady, renderSections = param.renderSections;
    var ref;
    var settings = (0,dist.useSettings)();
    var appEnabled = settings === null || settings === void 0 ? void 0 : (ref = settings.collection) === null || ref === void 0 ? void 0 : ref.appEnabled;
    var products = appEnabled ? [] : collection === null || collection === void 0 ? void 0 : collection.products;
    var sections = renderSections();
    // determines if default collection heading should be shown
    var hasVisibleHeroSection = (0,react.useMemo)(function() {
        if (!(sections === null || sections === void 0 ? void 0 : sections.length)) return false;
        var HERO_KEYS = [
            "hero",
            "collection-hero"
        ];
        return sections.some(function(param) {
            var props = param.props;
            return HERO_KEYS.includes(props === null || props === void 0 ? void 0 : props["data-comp"]) && !(props === null || props === void 0 ? void 0 : props.hidden);
        });
    }, [
        sections
    ]);
    // adding collection via section allows control of order of grid on the page
    // otherwise, collection is hardcoded after all sections
    var ref1 = (0,react.useMemo)(function() {
        if (!(sections === null || sections === void 0 ? void 0 : sections.length)) return {};
        var visibleCollectionIndex = sections.findIndex(function(param) {
            var props = param.props;
            return (props === null || props === void 0 ? void 0 : props["data-comp"]) === "collection" && !(props === null || props === void 0 ? void 0 : props.hidden);
        });
        var collectionPostitionIndex = visibleCollectionIndex >= 0 ? visibleCollectionIndex : sections.length;
        return {
            sectionsBeforeCollection: sections.slice(0, collectionPostitionIndex),
            sectionsAfterCollection: sections.slice(collectionPostitionIndex + 1)
        };
    }, [
        sections
    ]), sectionsBeforeCollection = ref1.sectionsBeforeCollection, sectionsAfterCollection = ref1.sectionsAfterCollection;
    var heading = collection === null || collection === void 0 ? void 0 : collection.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: heading && "Rhoback" ? "".concat(heading, " | ").concat("Rhoback") : heading || "Rhoback" || 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    !hasVisibleHeroSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-contained py-contained !pb-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto flex max-w-[var(--content-max-xl-width)]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-title-h2",
                                children: heading
                            })
                        })
                    }),
                    sectionsBeforeCollection || null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-contained py-contained",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Collection */.FE, {
                            handle: collection === null || collection === void 0 ? void 0 : collection.handle,
                            id: collection === null || collection === void 0 ? void 0 : collection.id,
                            appEnabled: appEnabled,
                            products: products,
                            productsReady: productsReady,
                            title: heading
                        })
                    }),
                    sectionsAfterCollection || null
                ]
            })
        ]
    });
}
CollectionTemplate.displayName = "CollectionTemplate";

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(3183);
;// CONCATENATED MODULE: ./src/pages/collections/[handle].jsx
/* provided dependency */ var process = __webpack_require__(4284);









// eslint-disable-next-line import/no-unresolved


var filterOutDraftProducts = function(product) {
    return product.status === "ACTIVE";
};
var __N_SSG = true;
function Collection(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var ref = (0,react.useState)(props.collection), collection = ref[0], setCollection = ref[1];
    var ref1 = (0,react.useState)(false), productsReady = ref1[0], setProductsReady = ref1[1];
    var setRecoilCollection = dist.store.recoil.useSetRecoilState(dist.store.state.collection);
    var collectionRef = (0,react.useRef)();
    collectionRef.current = collection;
    var fetchCache = (0,react.useRef)({});
    var fetchProduct = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(handle) {
            var isDev, siteUrl, host, response, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!fetchCache.current[handle]) return [
                            3,
                            3
                        ];
                        isDev = "production" === "development";
                        siteUrl = process.env.HOST_SITE_URL || "https://rhoback.com";
                        host = isDev ? "http://localhost:8080" : siteUrl;
                        return [
                            4,
                            fetch("".concat(host, "/json/products/").concat(handle, ".json"))
                        ];
                    case 1:
                        response = _state.sent();
                        _ = fetchCache.current;
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        _[handle] = _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            fetchCache.current[handle]
                        ];
                }
            });
        });
        return function fetchProduct(handle) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var n, i, promises, products, updatedCollection;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        n = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "12";
                        i = 0;
                        promises = collectionRef.current.products.map(function(product) {
                            if (!product.variants && i < n) {
                                i += 1;
                                return fetchProduct(product.handle);
                            }
                            return Promise.resolve(product);
                        });
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 1:
                        products = _state.sent();
                        updatedCollection = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collectionRef.current), {
                            products: products
                        });
                        setCollection(updatedCollection);
                        setRecoilCollection(updatedCollection);
                        return [
                            2,
                            updatedCollection
                        ];
                }
            });
        });
        return function loadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    var hasAllProductsOnLoad = collection.products.length < parseInt("12", 10);
    (0,react.useEffect)(function() {
        fetch("/json/collections/products/".concat(collection.handle, ".json")).then(function(response) {
            return response.json();
        }).then(function(result) {
            var remainingProducts = isPreview ? result : result.filter(filterOutDraftProducts);
            var fullCollection = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
                products: (0,_to_consumable_array/* default */.Z)(collection.products).concat((0,_to_consumable_array/* default */.Z)(remainingProducts))
            });
            setCollection(fullCollection);
            setRecoilCollection(fullCollection);
            setProductsReady(true);
        });
        return function() {
            setCollection(null);
            setRecoilCollection(null);
            setProductsReady(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        setRecoilCollection(collection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collection.handle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageHead */.yG, {
            page: props.page,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionTemplate, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                collection: collection,
                loadMore: loadMore,
                productsReady: hasAllProductsOnLoad || productsReady,
                renderSections: renderSections
            }))
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(593); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);